<template>
  <div
    v-if="options"
    v-loading="isLoading"
    :class="['grid-filter select', options.classes, {'is-clear': isClear}]"
    :style="options.styles">
    <el-form-item
      :label="fieldLabel"
      class="material-style"
    >
      <select-response
        :model.sync="model"
        :placeholder="options.placeholder"
        :isLoading="isLoading"
        :data="source"
        :size="options.size"
        :fields="{title: options.option.label, id: options.option.value}"
        :clearable="options.clearable"
        :disabled="disabled"
        @on-change="debounceHandleChange"/>
    </el-form-item>
  </div>
</template>

<script>
import mixins from '../mixins'

export default {
  name: 'FilterSelect',
  mixins: [mixins],
  props: {
    config: { type: Object },
    disabled: { type: Boolean, default: false },
    place: { type: String, default: 'column' },
    eventID: { type: String }
  },
  data () {
    return {
      model: this.config && (this.config.value || this.config.defaultValue),
      source: [],
      debounceHandleChange: null
    }
  },
  computed: {
    isClear () {
      return !(this.model)
    },
    fieldLabel () {
      return this.checkJsTemplate(this.config.label)
    },
    noValueTemplate () {
      return this.createValueTemplate(this.options.noValueTemplate)
    }
  },
  created () {
    this.$bus.$on(`on-set-filter-${this.eventID}`, this.handleSetFilterValue)
    this.debounceHandleChange = this.$_.debounce(this.handleChange, 100)
  },
  beforeDestroy () {
    this.$bus.$off(`on-set-filter-${this.eventID}`, this.handleSetFilterValue)
  },
  methods: {
    handleSetFilterValue (value) {
      this.model = value
      this.debounceHandleChange()
    },
    MODEL () {
      return {
        /* TODO:
            dataSource:
              Массив || Строка-путь к датасорсы
            normalization:
              Строка полей необходимые для корректной обработки шаблонизатором и если их нет в объекта
              то они будут созданы с пустыми значениями: "customField1,customField2"
       */
        // eslint-disable-next-line
        valueTemplate: '(${data.field} == ${isNaN(Number(data.value)) ? `"${data.value}"` : data.value})',
        noValueTemplate: function (data, root) {
          return data.optionsValue
        },
        value: '',
        defaultValue: '', // initialize value
        normalization: '',
        dataSource: null,

        placeholder: this.L10n('select'),
        classes: '',
        styles: {},
        size: '',
        clearable: true,

        option: {
          label: 'title',
          value: 'id',
          template: null
        }
      }
    },
    parseConfig (Options) {
      this.handle('parseStart')
      // reset data
      this.options = null
      this.source = []
      this.isLoading = true
      // update options
      this.options = this.$_.merge(this.MODEL(), this.config.options, Options || {});
      ['placeholder', 'dataSource'].forEach(key => {
        this.options[key] = this.checkEs6AndRun(this.options[key])
      })
      this.parseOptionsTemplate()
      // TODO: NEED STRONG APPLY DATA SOURCE OPTION, BECAUSE ARRAY(S) is MERGED
      if (Options && Options.dataSource) {
        if (typeof Options.dataSource === 'object') {
          this.options.dataSource = this.$_.merge({}, Options.dataSource)
        } else if (Array.isArray(Options.dataSource)) {
          this.options.dataSource = [...Options.dataSource]
        } else {
          this.options.dataSource = Options.dataSource
        }
      }
      this.setDefaultValue()
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      // start update dataSource
      // TODO: NOTE#2 In next version need add multiple parse dataSource
      // this.debounceUpdateDataSource()
      this.createSource()
    },
    createSource () {
      if (typeof this.options.dataSource === 'function') {
        this.parseSource(this.options.dataSource(null, this))
      } else if (Array.isArray(this.options.dataSource)) {
        this.parseSource(this.options.dataSource)
      } else if (typeof this.options.dataSource === 'string') {
        this.APIWatch(this.options.dataSource, (response) => {
          if (!response.isLoading) this.parseSource(response.records)
          this.isLoading = response.isLoading
        })
      }
    },
    parseSource (Items) {
      // set model
      this.source = [...Items]
      // TODO: NOTE#1 In next version need parse value from ARRAY and String
      // if (this.source.length) this.setValue(this.options.value, true)
      this.updateRendered()
      this.isLoading = false
      this.handle('init')
    },
    updateRendered () {
      if (this.model) {
        this.result = this.valueTemplate({ field: this.config.field, value: this.model, dataValue: this.mapDataSource[this.model] }, this)
        this.resultHuman = this.model
      } else {
        this.result = this.noValueTemplate({
          field: this.config.field,
          defaultValue: this.options.defaultValue,
          optionsValue: this.options.value
        }, this.$root)
        this.resultHuman = ''
      }
    },
    // HANDLERS
    handleChange () {
      this.updateRendered()
      this.handle('change')
    },
    handleClear () {
      this.model = ''
      this.handleChange()
    },
    /**
     * @name resetField
     * @desc Method for reset field data. It emits, when user click button 'clear-filter'
     */
    resetField () {
      if (this.options.clearable) {
        this.model = ''
      }
      this.updateRendered()
      this.handle('resetField')
    },
    handle (Type) {
      this.$emit('handle', {
        id: this.config.id,
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    }
  }
}
</script>
